import { AutoMap } from "@nartc/automapper";
import { Country } from "app/_models/country.model";

export class CalamityVm {
@AutoMap() calId : string ;
@AutoMap() calName : string;
@AutoMap() calKind : string;
@AutoMap() calCountry : Country;
@AutoMap() calLocation : string;
@AutoMap() calCreatedDate: Date = new Date();
@AutoMap() calLocalTime : Date = new Date();
@AutoMap() calSosinternationalCoordinatingAlarmcenter : string;
@AutoMap() calPassengerList : string;
@AutoMap() calLocalAlarmcenter : string;
@AutoMap() calGroupTravel : string;
@AutoMap() calTeamTowardsCalamity : string;
@AutoMap() calDescription : string;
@AutoMap() CalStatusNavigation : any;
}